// $(document).ready(function(){

//   // Product variant price update js start
//   var VariantId ; 
//   var variantIdFind;
//   var variantPriceFind;
//   var variantComPriceFind;
//   var CurrentPrice = $('.product-info__price .price__default .price__current');
//   var CurrentComparePrice = $('.product-info__price .price__default .price__was');
//   $(document).on('click', '.custom-select__listbox .custom-select__option', function(){
    
//     var $currentDropdown = $(this).closest('.option-selector');
//     var isFirstDropdown = $currentDropdown.is($('.option-selector').first());

//      setTimeout(function(){
//        var url = window.location.href;
//        VariantId = new URL(url).searchParams.get("variant");
//        // console.log(VariantId);
       
//        $('.get_variant').each(function(){
//          variantIdFind = $(this).attr('varid');
//          variantPriceFind = $(this).attr('varprice');
//          variantComPriceFind = $(this).attr('varcomprice');
//          // console.log(variantIdFind);
//           if(variantIdFind == VariantId){
//             // console.log(' This is Variant Id' + ' ' + variantIdFind + ' This is Variant Price' + ' ' + variantPriceFind + ' This is Variant Compare' + ' ' + variantComPriceFind);
//             CurrentPrice.text(variantPriceFind);
//             CurrentComparePrice.text(variantComPriceFind);
//           }  
//        });
//      },500);

//   });

  
//   var $wraps = $('.option-selector');
//   if (!$wraps.length) return;

//   var SELECTOR = '.ctm_part_drop.custom-select__option:not(.is-unavailable):not(.is-nonexistent)[data-value]:not([data-value=""])';

//   function autoSelect($wrap) {
//     if (!$wrap || !$wrap.length) return false;

//     var $csEl = $wrap.find('custom-select.ctm_parent_selectere').first();
//     var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part').first();
//     if (!$csEl.length || !$listbox.length || typeof $csEl[0].selectOption !== 'function') return false;

//     var $li = $listbox.find(SELECTOR).first();
//     if ($li.length) {
//       $csEl[0].selectOption($li[0]);
//       return true;
//     }
//     return false;
//   }

//   function watchAndSelect($wrap) {
//     if (!$wrap || !$wrap.length) return;
//     if (autoSelect($wrap)) return;

//     var observer = new MutationObserver(function() {
//       if (autoSelect($wrap)) observer.disconnect();
//     });

//     observer.observe($wrap[0], {
//       subtree: true,
//       childList: true,
//       attributes: true
//     });

//     setTimeout(function() {
//       observer.disconnect();
//     }, 3000);
//   }

//   $wraps.each(function(idx, wrap) {
//     var $wrap = $(wrap);
//     var $csEl = $wrap.find('custom-select.ctm_parent_selectere').first();
//     var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part').first();

//     if (!$csEl.length || !$listbox.length) return;

//     $listbox.on('click', '.custom-select__option', function() {
//       var $nextWrap = $wraps.eq(idx + 1);
//       if ($nextWrap.length) {
//         setTimeout(function() {
//           watchAndSelect($nextWrap);
//         }, 50);
//       }
//     });

//     var observer = new MutationObserver(function(mutations) {
//       mutations.forEach(function(m) {
//         if (
//           $(m.target).hasClass("is-selected") ||
//           $(m.target).attr("aria-selected") === "true"
//         ) {
//           var $nextWrap = $wraps.eq(idx + 1);
//           if ($nextWrap.length) {
//             setTimeout(function() {
//               watchAndSelect($nextWrap);
//             }, 50);
//           }
//         }
//       });
//     });

//     observer.observe($listbox[0], {
//       subtree: true,
//       attributes: true,
//       attributeFilter: ["class", "aria-selected"]
//     });
//   });
//   // Product variant price update js end

// });


$(document).ready(function(){

  var CurrentPrice = $('.product-info__price .price__default .price__current');
  var CurrentComparePrice = $('.product-info__price .price__default .price__was');

  var $wraps = $('.option-selector');
  if (!$wraps.length) return;

  var SELECTOR = '.ctm_part_drop.custom-select__option:not(.is-unavailable):not(.is-nonexistent)[data-value]:not([data-value=""])';

  $(document).on('click', '.custom-select__listbox .custom-select__option', function(){
    var $currentWrap = $(this).closest('.option-selector');
    var idx = $wraps.index($currentWrap);

    // --- Price Update ---
    setTimeout(function(){
      var url = window.location.href;
      var VariantId = new URL(url).searchParams.get("variant");

      $('.get_variant').each(function(){
        if($(this).attr('varid') == VariantId){
          CurrentPrice.text($(this).attr('varprice'));
          CurrentComparePrice.text($(this).attr('varcomprice'));
        }
      });
    },300);

    // $wraps.each(function(index) {
    //   if (index <= idx) return;

    //   setTimeout(function() {
    //     var $wrap = $wraps.eq(index);
    //     var $customSelect = $wrap.find('custom-select.ctm_parent_selectere, custom-select').first();
    //     var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part, .custom-select__listbox').first();
    //     var $options = $listbox.find('.custom-select__option');
    //     var $available = $options.not('.is-unavailable');
    //     var isLast = (index === $wraps.length - 1);

    //     if (!$customSelect.length || !$listbox.length || typeof $customSelect[0].selectOption !== 'function') return;

    //     if ($available.length) {
    //       $options.hide();   
    //       $available.show(); 
    //     } else {
    //       if (isLast) {
    //         $options.show().css({ opacity: 0.5, "pointer-events": "none" });
    //       } else {
    //         $options.hide();
    //       }
    //     }

    //     var $first = $available.first();
    //     if ($first.length) {
    //       $customSelect[0].selectOption($first[0]);
    //     }

    //   }, 300 * (index - idx)); 
    // });

     $wraps.each(function(index) {
      if (index <= idx) return;

      setTimeout(function() {
        var $wrap = $wraps.eq(index);
        var $customSelect = $wrap.find('custom-select.ctm_parent_selectere, custom-select').first();
        var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part, .custom-select__listbox').first();
        var $options = $listbox.find('.custom-select__option');
        var $available = $options.not('.is-unavailable');
        var isLast = (index === $wraps.length - 1);

        if (!$customSelect.length || !$listbox.length || typeof $customSelect[0].selectOption !== 'function') return;

        // --- Load vs Change Logic ---
        if (idx === -1) {
          // Page load case → sab options show (sold-out bhi)
          $options.show();
        } else {
          // Change case → sab options show, auto-select sirf available se
          $options.show();

          var $first = $available.first();
          if ($first.length) {
            $customSelect[0].selectOption($first[0]);
          } else if (isLast) {
            // Agar koi available nahi hai aur ye last dropdown hai → disable karo
            $options.css({ opacity: 0.5, "pointer-events": "none" });
          }
        }

      }, 300 * (index - idx));
    });


  });

});


(function () {
  if (window.innerWidth > 600) return

  function loadjQuery(callback) {
    if (window.jQuery) return callback();
    const script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const shadowRoot = originalAttachShadow.call(this, init);
    this._shadowRoot = shadowRoot;
    return shadowRoot;
  };

  function applyMobileStyles() {
    const host = document.querySelector('shopify-accelerated-checkout-cart');
    if (!host || !host._shadowRoot) {
      return setTimeout(applyMobileStyles, 500);
    }

    const $target = $(host._shadowRoot).find('.wallet-cart-grid');
    if ($target.length) {
      $target.css({ 
        'flex-direction': 'row',
        'gap': '10px',
        'align-items': 'center'
      });
    } 
  }

  window.addEventListener('DOMContentLoaded', () => {
    loadjQuery(() => setTimeout(applyMobileStyles, 300));
  });
})();

// Added Aug 2026:
// Size options are forced to remain dropdowns while Color uses swatches.
// Native/custom dropdown changes do not trigger the older custom-select click handler,
// so this listener updates variant pricing when .custom-variant-dropdown changes.
// ============================================================
// ============================================================
// VARIANT PRICE UPDATE
// Updates price when ANY product option changes:
// dropdowns, swatches, buttons, size selectors, etc.
// ============================================================

function gabUpdateVariantPrice() {

  setTimeout(function() {

    var VariantId =
      new URL(window.location.href).searchParams.get('variant');

    if (!VariantId) return;

    $('.get_variant').each(function() {

      if ($(this).attr('varid') == VariantId) {

        var variantPrice =
          $(this).attr('varprice');

        var variantComparePrice =
          $(this).attr('varcomprice');

        // Current selling price
        if (variantPrice) {

          $('.product-info__price .price__default .price__current')
            .text(variantPrice);

        }

        // Compare-at price
        if (variantComparePrice) {

          $('.product-info__price .price__default .price__was')
            .text(variantComparePrice);

        }

        return false;
      }

    });

  }, 300);

}


// ------------------------------------------------------------
// Custom dropdowns
// Size dropdowns and any other forced dropdown controls
// ------------------------------------------------------------

$(document).on(
  'change',
  '.custom-variant-dropdown',
  function() {

    gabUpdateVariantPrice();

  }
);


// ------------------------------------------------------------
// Enterprise option inputs
// Swatches, buttons and other standard variant controls
// ------------------------------------------------------------

$(document).on(
  'change',
  '.opt-btn.js-option',
  function() {

    gabUpdateVariantPrice();

  }
);

// ============================================================
// LINKED VARIANT DROPDOWNS
// Family Apparel: Shirt Style -> Size
//
// Filters Size options based on selected Shirt Style.
// IMPORTANT:
// This code only activates when the first dropdown contains
// the family apparel Shirt Style options.
//
// This prevents the logic from interfering with products that
// have other 2-option or 3-option variant configurations.
// ============================================================

$(document).ready(function () {

  var $dropdowns = $('.custom-variant-dropdown');

  // Need at least two dropdowns.
  if ($dropdowns.length < 2) return;

  var $styleDropdown = $dropdowns.eq(0);
  var $sizeDropdown  = $dropdowns.eq(1);


  // ==========================================================
  // SAFETY CHECK
  // Only activate this feature on Family Apparel products.
  // ==========================================================

  var styleValues = [];

  $styleDropdown.find('option').each(function () {
    styleValues.push($(this).val());
  });

  var familyStyleValues = [
    'Baby Onesie',
    'Infant T-Shirt',
    'Toddler T-Shirt',
    'Youth T-Shirt',
    'Adult T-Shirt'
  ];

  var isFamilyApparelProduct = familyStyleValues.some(function (style) {
    return styleValues.indexOf(style) !== -1;
  });

  // If this is NOT the Shirt Style dropdown,
  // exit immediately and let Enterprise handle the product normally.
  if (!isFamilyApparelProduct) {
    return;
  }


  // ==========================================================
  // SAVE ORIGINAL SIZE OPTIONS
  // ==========================================================

  var originalSizeOptions = [];

  $sizeDropdown.find('option').each(function () {

    originalSizeOptions.push({
      value: $(this).val(),
      text: $(this).text()
    });

  });


  // ==========================================================
  // GET VALID SIZES FOR CURRENT SHIRT STYLE
  // ==========================================================

  function getValidSizes() {

    var validSizes = [];

    $('.opt-btn.js-option').each(function () {

      var $input = $(this);
      var name = $input.attr('name') || '';

      // Only inspect Enterprise's Size option group.
      if (name.indexOf('-size-option') === -1) {
        return;
      }

      var sizeValue = $input.val();

      var $label = $(
        'label[for="' + $input.attr('id') + '"]'
      );

      var isNonexistent =
        $input.hasClass('is-nonexistent') ||
        $label.hasClass('is-nonexistent');

      if (
        !isNonexistent &&
        validSizes.indexOf(sizeValue) === -1
      ) {

        validSizes.push(sizeValue);

      }

    });

    return validSizes;
  }


  // ==========================================================
  // REBUILD SIZE DROPDOWN
  // ==========================================================

  function rebuildSizeDropdown() {

    var validSizes = getValidSizes();

    // Enterprise may still be recalculating options.
    // If we don't have valid sizes yet, don't touch anything.
    if (!validSizes.length) {
      return;
    }

    var currentSize = $sizeDropdown.val();


    // --------------------------------------------------------
    // Rebuild dropdown with valid sizes only
    // --------------------------------------------------------

    $sizeDropdown.empty();

    originalSizeOptions.forEach(function (opt) {

      if (validSizes.indexOf(opt.value) !== -1) {

        $sizeDropdown.append(
          $('<option>', {
            value: opt.value,
            text: opt.text
          })
        );

      }

    });


    // ========================================================
    // CURRENT SIZE IS STILL VALID
    // ========================================================

    if (validSizes.indexOf(currentSize) !== -1) {

      $sizeDropdown.val(currentSize);

      return;
    }


    // ========================================================
    // CURRENT SIZE IS INVALID FOR NEW SHIRT STYLE
    //
    // Example:
    // Baby Onesie / NB
    //      ->
    // Toddler T-Shirt / 2T
    // ========================================================

    var firstValidSize = validSizes[0];

    $sizeDropdown.val(firstValidSize);


    // --------------------------------------------------------
    // Find Enterprise's corresponding hidden Size input
    // --------------------------------------------------------

    var $matchingSizeInput =
      $('.opt-btn.js-option').filter(function () {

        var name = $(this).attr('name') || '';

        return (
          name.indexOf('-size-option') !== -1 &&
          $(this).val() === firstValidSize
        );

      }).first();


    // --------------------------------------------------------
    // Tell Enterprise about the new Size
    // --------------------------------------------------------

    if ($matchingSizeInput.length) {

      $matchingSizeInput.prop('checked', true);

      $matchingSizeInput[0].dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

    }


    // --------------------------------------------------------
    // Also notify the visible dropdown
    // --------------------------------------------------------

    if ($sizeDropdown.length) {

      $sizeDropdown[0].dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

    }

  }


  // ==========================================================
  // INITIAL PAGE LOAD
  // ==========================================================

  setTimeout(function () {

    rebuildSizeDropdown();

  }, 200);


  // ==========================================================
  // SHIRT STYLE CHANGES
  // ==========================================================

  $styleDropdown.on('change', function () {

    /*
      Enterprise needs a moment to recalculate which Size
      choices exist for the newly selected Shirt Style.
    */

    setTimeout(function () {

      rebuildSizeDropdown();

    }, 150);

  });

});

// ============================================================
// VARIANT UI READY
// Reveal variant controls only after custom swatch/dropdown
// transformations have finished.
// ============================================================

$(document).ready(function () {

  setTimeout(function () {
    document.documentElement.classList.add('gab-variant-ui-ready');
  }, 25);

});

// Safety fallback:
setTimeout(function () {
  document.documentElement.classList.add('gab-variant-ui-ready');
}, 400);